import { AuthResponseDto, EmailDto, OtpVerifyDto } from '@sportspredict/shared';
import api from './base-api';
import { updateSessionAction } from '../slices/auth/actions/update-session.action';

export const otpApi = api.injectEndpoints({
	endpoints: (builder) => ({
		requestOtp: builder.mutation<void, EmailDto>({
			query: (payload) => ({
				url: 'auth/sign-in/otp/request',
				method: 'POST',
				body: payload,
			}),
			extraOptions: {
				skipAuth: true,
			},
		}),
		verifyOtp: builder.mutation<
			AuthResponseDto & { isNewUser?: boolean; email?: string },
			OtpVerifyDto
		>({
			query: (payload) => ({
				url: 'auth/sign-in/otp/verify',
				method: 'POST',
				body: payload,
			}),
			async onQueryStarted(_, { dispatch, queryFulfilled }) {
				try {
					const { data } = await queryFulfilled;
					if (data.isNewUser) return;
					dispatch(updateSessionAction(data as any));
					dispatch(api.util.resetApiState());
				} catch (error: unknown) {
					console.error('OTP verification failed:', error);
				}
			},
			invalidatesTags: ['UserProfile'],
			extraOptions: {
				skipAuth: true,
			},
		}),
	}),
});

export const { useRequestOtpMutation, useVerifyOtpMutation } = otpApi;
